import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_16'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_16',
  name: 'Does the facility have any of the following safety measures in place related to portable ladders?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PORTABLE_LADDERS_HAVE_BEEN_INSPECTED_FOR_DAMAGE_AND_MAINTENANCE',
      text: 'Portable ladders have been inspected for damage and maintenance',
      externalIds: [
        {
          id: 'hs-37--1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'LADDERS_HAVE_LOCKING_DEVICES_SO_THAT_THEY_ARE_SECURE_WHEN_OPEN_',
      text: 'Ladders have locking devices so that they are secure when open or in use',
      externalIds: [
        {
          id: 'hs-37--1-3x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_ARE_TRAINED_TO_PLACE_LADDERS_ON_A_SECURE_EVEN_SURFACE_W',
      text: 'Workers are trained to place ladders on a secure, even surface when in use',
      externalIds: [
        {
          id: 'hs-37--1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THE_FACILITY_PROHIBITS_TYING_OR_FASTENING_TOGETHER_LADDERS_TO_A',
      text: 'The facility prohibits tying or fastening together ladders to achieve additional height',
      externalIds: [
        {
          id: 'hs-37--1-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THE_FACILITY_PROHIBITS_PLACING_LADDERS_IN_FRONT_OF_ANY_DOORS_TH',
      text: 'The facility prohibits placing ladders in front of any doors that may or may not be locked or guarded',
      externalIds: [
        {
          id: 'hs-37--1-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THE_FACILITY_PROHIBITS_USING_LADDERS_IN_THE_HORIZONTAL_POSITION',
      text: 'The facility prohibits using ladders in the horizontal position as a platform or scaffolding',
      externalIds: [
        {
          id: 'hs-37--1-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'LADDERS_ARE_SECURED_WHEN_NOT_IN_USE',
      text: 'Ladders are secured when not in use',
      externalIds: [
        {
          id: 'hs-37--1-8x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-37--1-9x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'PORTABLE_LADDERS_HAVE_BEEN_INSPECTED_FOR_DAMAGE_AND_MAINTENANCE',
                'LADDERS_HAVE_LOCKING_DEVICES_SO_THAT_THEY_ARE_SECURE_WHEN_OPEN_',
                'WORKERS_ARE_TRAINED_TO_PLACE_LADDERS_ON_A_SECURE_EVEN_SURFACE_W',
                'THE_FACILITY_PROHIBITS_TYING_OR_FASTENING_TOGETHER_LADDERS_TO_A',
                'THE_FACILITY_PROHIBITS_PLACING_LADDERS_IN_FRONT_OF_ANY_DOORS_TH',
                'THE_FACILITY_PROHIBITS_USING_LADDERS_IN_THE_HORIZONTAL_POSITION',
                'LADDERS_ARE_SECURED_WHEN_NOT_IN_USE',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-mat-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16360,
  sectionId: '2.2.9.6',
  impactArea: 'Materials Handling and Storage',
  impactAreaId: 'MATERIALS_HANDLING_AND_STORAGE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
